import React from "react";
import { navigate } from "@reach/router";
import gql from "graphql-tag";
import styled from "@emotion/styled";
import { constants } from "@services";
import { Box, Image, Flex, TextUppercase, TouchableOpacity, BulkShopFlag } from "@atoms";
import { LinkType } from "@types";
import { LinkBlockPromoLabel } from "../LinkBlockPromoLabel";
import { LinkBlockGives } from "../LinkBlockGives";
import { LinkBlockFragment } from "./__generated__/LinkBlockFragment";

// == Types ================================================================

interface IProps {
  link: LinkBlockFragment;
}

// == Constants ============================================================

const FRAGMENTS = {
  fields: gql`
    fragment LinkBlockFragment on Link {
      id
      type
      giftcardType
      name
      image
      logoImage
      giveSentence
      terms
      promotionInfo {
        promotionLabel
        promotionSecondaryLabel
        promotionEndsAt
      }
      isBulkShop
    }
  `,
};

// == Component ============================================================

const LinkBlock = ({ link }: IProps) => {
  const { id: linkId, type: linkType, isBulkShop, image, name, giveSentence, promotionInfo } = link;

  const { promotionEndsAt, promotionSecondaryLabel, promotionLabel } = promotionInfo;
  const { GIFTCARDOFFER } = LinkType;

  const onClick = () => {
    navigate(`?${constants.linkParam}=${linkId}`);
  };

  const isGiftcard = linkType === GIFTCARDOFFER;
  // temp because clicking a link block on a carousel cauess it to perm faded
  // <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onClick}></TouchableOpacity>
  return (
    <TouchableOpacity containerProps={{ style: { width: "100%" } }} onTouch={onClick}>
      <Flex flexDirection="column">
        <Box position="relative">
          {isBulkShop && <EBulkShopFlag />}

          {!!image && (
            <Image
              alt="link-image"
              borderRadius={isGiftcard ? "giftcard" : 0}
              boxShadow="lightShadow"
              loading="lazy"
              src={`${image}&w=250&h=187.5&fit=fill&bg=fff`}
            />
          )}

          {promotionLabel && (
            <LinkBlockPromoLabel
              bottom="20px"
              label={promotionLabel}
              left="0"
              position="absolute"
            />
          )}
        </Box>

        <TextUppercase ellipsis as="p" fontSize={[0]} pt={2} textAlign="center">
          {name}
        </TextUppercase>
        <LinkBlockGives
          giveSentence={giveSentence}
          isBulkShop={isBulkShop}
          promoEndsAt={promotionEndsAt}
          secondaryLabel={promotionSecondaryLabel}
        />
      </Flex>
    </TouchableOpacity>
  );
};

export default LinkBlock;

LinkBlock.fragments = FRAGMENTS;

// == Styles ===============================================================

const EBulkShopFlag = styled(BulkShopFlag)`
  position: absolute;
  top: 0;
  right: 5px;
  height: 45px;
  width: 20px;
`;
